import React, { useEffect, useId, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
// import profile from "../../assets/images/profile-img.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import backgroundLogin from "../../assets/images/opdc_builder_background.jpg";
import backgroundLoginPrev from "../../assets/images/working_space.jpg";
import backgroundLogin2 from "../../assets/images/opdc_builder_background2.png";
import FadeIn from "react-fade-in/lib/FadeIn";
import Lottie from "react-lottie";
import * as unLock from "./unlock.json";
import * as accessDenied from "./accessDenied.json";
import KorPorRorLogo from "../../assets/images/1200px-Opdc_preview_rev_1.png";
import * as confirm from "../../assets/lottieAnimation/confirm.json";
const baseURL = process.env.REACT_APP_API_CORS;
const codeVersion = process.env.REACT_APP_CODE_VERSION;

const LoginPage = () => {
  document.title = "Login | FlexibleTime";
  
  const navigate = useNavigate();
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&.])[A-Za-z\d@$!%*#?&.]{8,}$/;

  const [canLogin, setCanLogin] = useState(null);
  const [modalCheck, setModalCheck] = useState(false);
  const [token, setToken] = useState("");
  const [modalVerify, setModalVerify] = useState(false);
  const [modalSetPassword, setModalSetPassword] = useState(false);
  const [isUsernameCorrect, setIsUsernameCorrect] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [data, setData] = useState({
    username: "",
    password: "",
  });

  const handleLogout = async (name, token, position) => {
    document.cookie =
      name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      token + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      position + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  useEffect(() => {
    handleLogout("userData", "userToken", "userPosition");
    handleLogout("userEofficeAccessToken", "userEofficeAccessToken");
  }, []);

  const handleModalVerify = async () => {
    if (modalVerify === false) {
      setModalVerify(true);
    }
    if (modalVerify === true) {
      setModalVerify(false);
      verifyValidation.values.idcard = "";
    }
  };

  const handleModalSetPassword = async () => {
    setModalSetPassword(!modalSetPassword);
    setPassValidation.values.password = "";
    setPassValidation.values.conPassword = "";
  };

  const verifyValidation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: data.username,
      idcard: "",
    },

    validationSchema: Yup.object().shape({
      idcard: Yup.number()
        .typeError("ต้องเป็นตัวเลขเท่านั้น")
        .required("กรุณากรอกรหัสบัตรประชาชน")
        .test(
          "len",
          "ต้องมีความยาว 13 ตัว",
          (val) => val && val.toString().length === 13
        ),
    }),
    onSubmit: async (values) => {
      try {
        const res = await axios.post(baseURL + "/login/verify", {
          username: values?.username,
          idcard: values?.idcard,
        });
        if (res?.data?.status === true) {
          setToken(res?.data?.token);
          await handleModalVerify();
          await handleModalSetPassword();
        } else if (res?.data?.status === false) {
          alert("รหัสบัตรประชาชน ไม่ถูกต้อง");
        }
      } catch (err) {
        // console.error(err);
      }
    },
  });

  const setPassValidation = useFormik({
    enableReinitialize: true,

    initialValues: {
      password: "",
      conPassword: "",
    },

    validationSchema: Yup.object().shape({
      password: Yup.string()
        .required("กรุณากรอก Password")
        .min(8, "ต้องมีความยาวอย่างน้อย 8-20 ตัวอักษร")
        .max(20, "ต้องมีความยาวไม่เกิน 20 ตัวอักษร")
        .matches(
          passwordRegex,
          "ต้องมีตัวเลขและอักระพิเศษ, และมีความยาว 8-20 ตัวอักษร"
        ),
      conPassword: Yup.string()
        .required("กรุณากรอกรหัสผ่านอีกครั้ง")
        .min(8, "ต้องมีความยาวอย่างน้อย 8-20 ตัวอักษร")
        .max(20, "ต้องมีความยาวไม่เกิน 20 ตัวอักษร")
        .matches(
          passwordRegex,
          "ต้องมีตัวเลขและอักระพิเศษ, และมีความยาว 8-20 ตัวอักษร"
        )
        .oneOf([Yup.ref("password"), null], "รหัสผ่านไม่ตรงกัน"),
    }),

    onSubmit: async (values) => {
      try {
        const res = await axios.post(
          `${baseURL}/login/resetPassword`,
          {
            password: values.password,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        await handleModalSetPassword();
        await handleOpenSubmitSuccess();
        setCanLogin(true);
      } catch (err) {
        // console.error(err);
      }
    },
  });

  const loginValidation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: "",
      password: "",
    },

    validationSchema: Yup.object().shape({
      username: Yup.string().required("กรุณากรอกบัญชีผู้ใช้"),
      password: Yup.string()
        .required("กรุณากรอกรหัสผ่าน")
        .min(8, "ต้องมีความยาวอย่างน้อย 8-20 ตัวอักษร")
        .max(20, "ต้องมีความยาวไม่เกิน 20 ตัวอักษร"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await axios.post(`${baseURL}/login`, values);
        await handleLogout("userData", "userToken", "userPosition");
        await handleOpenModal(res?.data?.status);
        if (res.data.status !== false) {
          setCanLogin(() => true);
          handleOpenModal(true);
          const user = res?.data?.user;
          const position = user?.position;

          delete user?.position;
          await setCookie(
            "userData",
            "userToken",
            "userPosition",
            res?.data?.user,
            res?.data?.token,
            position,
            1
          );
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else if (res?.data?.status === false) {
          setCanLogin(() => false);
          handleOpenModal(false);
        }
      } catch (err) {
        // console.error(err);
      }
    },
  });

  const setCookie = async (
    nameProfile,
    nameToken,
    namePosition,
    payload,
    token,
    position,
    duration
  ) => {
    let expires;
    if (duration) {
      var date = new Date();
      date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1000);
      expires = `expires=${date.toUTCString()}`;
    }

    const serializedObject = await JSON.stringify(payload);
    const positionObject = await JSON.stringify(position);

    document.cookie =
      (await nameProfile) +
      "=" +
      encodeURIComponent(serializedObject) +
      ";" +
      expires +
      "; path=/";
    document.cookie = nameToken + "=" + token + ";" + expires + "; path=/";
    document.cookie = namePosition + "=" + encodeURIComponent(positionObject) + ";" + expires + "; path=/";
  };

  const handleCheckUser = async (username) => {
    handleLogout("userData", "userToken", "userPosition");
    try {
      const res = await axios.get(baseURL + `/login/username/${username}`);
      if (res?.data?.firstLogin === 1 && res?.data?.status === true) {
        setCanLogin(true);
        setIsUsernameCorrect(res?.data?.status);
      } else if (res?.data?.firstLogin === 0 && res?.data?.status === true) {
        setCanLogin(false);
        setModalVerify(res?.data?.status);
      } else if (res?.data?.status === false) {
        setCanLogin(false);
        setIsUsernameCorrect(res?.data?.status);
        loginValidation.setErrors({
          username: "ไม่พบบัญชีผู้ใช้นี้ กรุณากรอกบัญชีผู้ใช้ให้ถูกต้อง",
        });
      }
    } catch (err) {
      // console.error(err);
    }
  };

  const handleOpenModal = async (status) => {
    setModalCheck(true);
    setTimeout(async () => {
      await handleCloseModal(status);
    }, 1300);
  };

  const handleCloseModal = async (status) => {
    setModalCheck(false);

    if (status === false) {
      setCanLogin(!status);
    }
  };

  const handleOpenSubmitSuccess = async () => {
    setSubmitSuccess(true);

    setTimeout(() => {
      setSubmitSuccess(false);
    }, 1900);
  };
  const handleCloseSubmitSuccess = async () => {
    setSubmitSuccess(false);
  };

  const [show, setShow] = useState(false);
  const [isFirstClick, setIsFirstClick] = useState(true);

  const handleClick = () => {
    if (isFirstClick) {
      setShow(true);
      setIsFirstClick(false);
    }
  };

  return (
    <React.Fragment>
      <div className="account-pages">
        <img
          alt="background-login"
          style={{
            backgroundSize: "cover",
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: "-1",
            opacity: "0.7",
          }}
          src={backgroundLogin}
        // src="https://wallpapercave.com/wp/wp2939895.jpg"
        />
        <Container>
          {/* <Modal
            size="md"
            centered
            isOpen={show}
            onKeyDown={(e) => {if (e.key === 'Enter')setShow(false)}}
            tabIndex="0"
            toggle={() => {setShow(false);}}
          >
            <ModalHeader>
             ใช้ username จากระบบเดิม (smart.opdc.go.th)
            </ModalHeader>
            <ModalFooter>
              <Button className="btn btn-primary btn-block" onClick={() => {setShow(false);}}>
                รับทราบ
              </Button>
            </ModalFooter>
          </Modal> */}
          <Row
            style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}
            className=""
          >
            {/* <Row className="justify-content-center"> */}
            <Col lg={6} md={8} sm={12}   >
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                <button
                  className="btn btn-primary btn-block"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "transparent",
                    cursor: "default",
                    padding: "10px",
                  }}
                  onClick={() => {
                    setCanLogin(true);
                  }}
                >
                  คลิก
                </button>
                
                  <img src={backgroundLogin2} alt="" className="w-sm-100 h-sm-100 img-fluid"/>
                        
                  {/* <Row className="d-flex">
                    <Col lg={7} sm={8} xs={12}  >
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          ยินดีต้อนรับเข้าสู่สำนักงาน ก.พ.ร
                        </h5>
                      </div>
                    </Col>
                    <Col
                      className="d-flex align-items-center justify-content-start py-4 px-4"
                    >
                      <div>
                        <img src={KorPorRorLogo} alt="" className="w-sm-100 h-sm-100 img-fluid" />
                      </div>
                    </Col>
                  </Row> */}
                </div>

                <CardBody>
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      loginValidation.handleSubmit();
                      return false;
                    }}
                  >
                    {/* {viewType !== "SetPassword" ? ( */}
                    <FormGroup floating className="position-relative">
                      <Input
                        id="username"
                        name="username"
                        placeholder="Enter Username"
                        type="text"
                        onClick={() => {
                          handleClick()
                        }}
                        onBlur={async (e) => {
                          loginValidation.handleBlur(e);
                          handleCheckUser(e.target.value);
                        }}
                        onChange={(e) => {
                          loginValidation.handleChange(e);
                          setData((prev) => ({
                            ...prev,
                            username: e.target.value,
                          }));
                          // handleCheckUser(e.target.value)
                        }}
                        value={loginValidation.values.username}
                        invalid={
                          loginValidation.touched.username &&
                            loginValidation.errors.username &&
                            isUsernameCorrect === false
                            ? true
                            : false
                        }
                        valid={
                          loginValidation.touched.username &&
                            !loginValidation.errors.username &&
                            isUsernameCorrect === true
                            ? true
                            : false
                        }
                        className="flex-grow-2"
                      />
                      <Label htmlFor="username" className="form-label">
                        บัญชีผู้ใช้
                      </Label>
                      {loginValidation.touched.username &&
                        loginValidation.errors.username &&
                        isUsernameCorrect === false ? (
                        <FormFeedback>
                          {loginValidation.errors.username}
                        </FormFeedback>
                      ) : (
                        <FormFeedback valid>บัญชีผู้ใช้ถูกต้อง</FormFeedback>
                      )}
                    </FormGroup>

                    {/* {viewType === "VerifyUser" ? ( */}
                    {/* <FormGroup floating>
                      <Input
                        id="idcard"
                        name="idcard"
                        placeholder="Enter idcard"
                        type="text"
                        onChange={(e) => {
                          setData(prev => ({...prev, idcard: e.target.value}));
                        }}
                      />
                      <Label className="form-label">รหัสบัตรประชาชน 13 หลัก</Label>
                    </FormGroup> */}
                    {/* ) : null} */}

                    {/* {viewType === "SetPassword" || viewType === "Login" ? ( */}
                    <FormGroup floating className="position-relative">
                      <Input
                        id="password"
                        name="password"
                        placeholder="Enter Password"
                        type="password"
                        disabled={
                          // loginValidation.values.username === "" ? true : false
                          canLogin ? false : true
                        }
                        onBlur={loginValidation.handleBlur}
                        onChange={loginValidation.handleChange}
                        value={loginValidation.values.password}
                        invalid={
                          loginValidation.touched.password &&
                            loginValidation.errors.password
                            ? true
                            : false
                        }
                        // valid={
                        //   loginValidation.touched.password &&
                        //   !loginValidation.errors.password
                        //     ? true
                        //     : false
                        // }
                        className="flex-grow-2"
                      />
                      <Label htmlFor="password" className="form-label">
                        รหัสผ่าน
                      </Label>

                      {
                        loginValidation.touched.password &&
                          loginValidation.errors.password ? (
                          <FormFeedback>
                            {loginValidation.errors.password}
                          </FormFeedback>
                        ) : null
                        // (
                        //   <FormFeedback valid>Password สามารถใช้ได้</FormFeedback>
                        // )
                      }
                    </FormGroup>
                    {/* ) : null} */}

                    {/* {viewType === "SetPassword" ? ( */}
                    {/* <FormGroup floating>
                        <Input
                          name="conpassword"
                          type="password"
                          placeholder="Enter Confirm Password"
                          onChange={(e) => {
                            setData(prev => ({...prev, conpassword: e.target.value}));
                          }}
                        />
                        <Label>Confirm Password</Label>
                        {data.passwordMatch === false ? <FormFeedback>Passwords do not match!</FormFeedback> : null}
                      </FormGroup> */}
                    {/* ) : null} */}
                    {/* <FormGroup row className="text-end">
                      <Col xxl={12}>
                        <Link className="">ลืมรหัสผ่าน?</Link>
                      </Col>
                    </FormGroup> */}
                    <FormGroup row>
                      <Col md={12}>
                        <button
                          className="btn btn-primary btn-block font-size-16 w-100"
                          type="submit"
                        >
                          เข้าสู่ระบบ
                        </button>
                      </Col>
                      <Col md={12}>
                        <button
                          className="btn btn-info btn-block font-size-16 w-100 mt-2"
                          onClick={() => {
                            var url = window.location.toString();
                            window.location = url.replace('/login', '/login-eoffice');
                          }}
                        >
                          เข้าสู่ระบบผ่าน E-Office<i class="ms-2 fa-solid fa-square-arrow-up-right"></i>
                        </button>
                      </Col>
                    </FormGroup>
                    <span>{codeVersion}</span>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal centered isOpen={modalCheck} toggle={() => handleCloseModal()}>
            <ModalHeader></ModalHeader>
            <ModalBody
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // height: "50vh",
              }}
            >
              <Container>
                <Row>
                  <Col
                    xxl={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="p-4"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                        height: "150px",
                        width: "150px",
                        border: "5px solid black",
                      }}
                    >
                      {canLogin === false ? (
                        <FadeIn>
                          <Lottie
                            options={{
                              loop: true,
                              autoplay: true,
                              animationData: accessDenied.default,
                              rendererSettings: {
                                preserveAspectRatio: "xMidYMid slice",
                              },
                            }}
                            width={180}
                            height={100}
                          />
                        </FadeIn>
                      ) : (
                        <FadeIn>
                          <Lottie
                            options={{
                              loop: true,
                              autoplay: true,
                              animationData: unLock.default,
                              rendererSettings: {
                                preserveAspectRatio: "xMidYMid slice",
                              },
                            }}
                            width={180}
                            height={100}
                          />
                        </FadeIn>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="d-flex justify-content-center" xxl={12}>
                    {!canLogin && (
                      <div>
                        <h3>Password ไม่ถูกต้อง</h3>
                      </div>
                    )}
                    {/* {setCanLogin(true)} */}
                  </Col>
                </Row>
              </Container>
            </ModalBody>
          </Modal>
          <Modal centered isOpen={modalVerify} toggle={handleModalVerify}>
            <ModalHeader toggle={handleModalVerify}>ยืนยันตัวตน</ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  verifyValidation.handleSubmit();
                  return false;
                }}
              >
                <FormGroup
                  row
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Label className="text-end" xs={4}>
                    บัญชีผู้ใช้
                  </Label>
                  <Col>
                    <Input
                      disabled
                      type="text"
                      name="username"
                      placeholder="กรุณาระบุ username"
                      value={verifyValidation.values.username}
                      onBlur={verifyValidation.handleBlur}
                      onChange={verifyValidation.handleChange}
                      invalid={
                        verifyValidation.touched.username &&
                        verifyValidation.errors.username
                      }
                    />
                    {verifyValidation.touched.username &&
                      verifyValidation.errors.username ? (
                      <FormFeedback>
                        {verifyValidation.errors.username}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={4}>
                    เลขบัตรประจำตัวประชาชน
                  </Label>
                  <Col>
                    <Input
                      type="text"
                      name="idcard"
                      inputMode="numeric"
                      placeholder="กรุณาระบุเลขบัตรประจำตัวประชาชน"
                      value={verifyValidation.values.idcard}
                      onBlur={verifyValidation.handleBlur}
                      onChange={verifyValidation.handleChange}
                      invalid={
                        verifyValidation.touched.idcard &&
                        verifyValidation.errors.idcard
                      }
                    />
                    {verifyValidation.touched.idcard &&
                      verifyValidation.errors.idcard ? (
                      <FormFeedback>
                        {verifyValidation.errors.idcard}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup
                  row
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  <Col sm={3} xs={6}>
                    <Button className="w-100" color="success" type="submit">
                      ยืนยัน
                    </Button>
                  </Col>
                  <Col sm={3} xs={6}>
                    <Button
                      className="w-100"
                      color="danger"
                      onClick={handleModalVerify}
                    >
                      ยกเลิก
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </ModalBody>
          </Modal>
          <Modal
            size="lg"
            centered
            isOpen={modalSetPassword}
            toggle={() => {
              handleModalSetPassword();
            }}
          >
            <ModalHeader
              toggle={() => {
                handleModalSetPassword();
              }}
            >
              ตั้งรหัสผ่าน
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  setPassValidation.handleSubmit();
                  return false;
                }}
              >
                <FormGroup
                  row
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Label className="text-end" xxl={3} xl={4} lg={4} md={4}>
                    กรอกรหัสผ่าน
                  </Label>
                  <Col xxl={5} xl={6} md={6}>
                    <Input
                      type="text"
                      name="password"
                      placeholder="กรอกรหัสผ่าน"
                      value={setPassValidation.values.password}
                      onBlur={setPassValidation.handleBlur}
                      onChange={(e) => {
                        setPassValidation.handleChange(e);
                      }}
                      invalid={
                        setPassValidation.touched.password &&
                          setPassValidation.errors.password
                          ? true
                          : false
                      }
                    />
                    {setPassValidation.touched.password &&
                      setPassValidation.errors.password ? (
                      <FormFeedback>
                        {setPassValidation.errors.password}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup
                  row
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Label className="text-end" xxl={3} xl={4}>
                    กรอกรหัสผ่านอีกครั้ง
                  </Label>
                  <Col xxl={5} xl={6}>
                    <Input
                      type="text"
                      name="conPassword"
                      placeholder="กรอกรหัสผ่านอีกครั้ง"
                      value={setPassValidation.values.conPassword}
                      onBlur={setPassValidation.handleBlur}
                      onChange={(e) => {
                        setPassValidation.handleChange(e);
                      }}
                      invalid={
                        setPassValidation.touched.conPassword &&
                          setPassValidation.errors.conPassword
                          ? true
                          : false
                      }
                    />
                    {setPassValidation.touched.conPassword &&
                      setPassValidation.errors.conPassword ? (
                      <FormFeedback>
                        {setPassValidation.errors.conPassword}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup
                  row
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  <Col xxl={2} xl={2}>
                    <Button className="w-100" type="submit" color="success">
                      บันทึก
                    </Button>
                  </Col>
                  <Col xxl={2} xl={2}>
                    <Button className="w-100" color="danger">
                      ย้อนกลับ
                    </Button>
                  </Col>
                  <Col xxl={2} xl={1}></Col>
                </FormGroup>
              </Form>
            </ModalBody>
          </Modal>
          <Modal
            centered
            isOpen={submitSuccess}
            toggle={() => {
              handleCloseSubmitSuccess();
            }}
          >
            <ModalBody>
              <Row>
                <Col xxl={12} className="d-flex justify-content-center">
                  <h1>ดำเนินการเสร็จสิ้น</h1>
                </Col>
                <Col xxl={12} className="d-flex justify-content-center mt-4">
                  <div
                    className="p-4"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      height: "150px",
                      width: "150px",
                      border: "5px solid black",
                    }}
                  >
                    <FadeIn>
                      <Lottie
                        options={{
                          loop: true,
                          autoplay: true,
                          animationData: confirm.default,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice",
                          },
                        }}
                        width={180}
                        height={180}
                      />
                    </FadeIn>
                  </div>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment >
  );
};

export default LoginPage;
